import type { ListBuilderList } from '../../../types';
import { createNearMeColumns } from '../columns';
import {
	createClientKanbanConfig,
	DEFAULT_LIST_REQUIRED_FIELDS,
} from '../shared';

/**
 * Near Me list configuration
 * Clients within 25 miles of current location, sorted by distance
 */
export const defaultClientsNearMeList: ListBuilderList = {
	id: 'default-clients-near-me',
	cacheTTL: 60000,
	name: 'Near Me (25mi)',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	defaultSortId: 'column-proximity-asc',
	filterRules: {
		nearMe: {
			defaultValue: [
				{
					id: 'me:25',
					label: 'Me (Current Location) - 25 miles',
					data: {
						centerType: 'me',
						radius: 25,
					},
				},
			],
		},
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
	},
	columns: createNearMeColumns(),
	description:
		'Clients within 25 miles of current location, sorted by distance',
	requiredFields: [
		...DEFAULT_LIST_REQUIRED_FIELDS,
		'client.distanceFromCenter',
	],
	sortOrder: 7,
	kanbanConfig: createClientKanbanConfig(),
};
